import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import * as Cookies from 'js-cookie';
import 'MagnificPopup';
import { wcagOptions } from "./wcag";
import { bookingFormCommon } from "./c005-bookingform-common";

export class smartAlertsWidget {
	private wcag = new wcagOptions();
	private bcommon = new bookingFormCommon();
	private $smAlertsError: Array<string> = [];
	$smAlertsValidator: any = $('#smartalertsWidget-validator');
	$smAlertsErrorValidation: any = $('.smartalerts-error--validation');

	smartAlertsPopUpInit(): any {
		let smartAlertsContainer: any = $('.smartalerts-container .smartalerts-form--container');
		smartAlertsContainer.magnificPopup({
			items: {
				src: '#smart-alerts-popup'
			},
			type: 'inline',
			midClick: false,
			enableEscapeKey: false,
			showCloseBtn: true,
			closeOnBgClick: false,
			closeOnContentClick: false
		});
	}
	smartAlertsSubmit(): any {
		let $smartAlertsButton: any = $('.smartalerts-container .smartalerts-btn');
		let $scope: any = $('#smart-alerts-popup');
		let $smAlertsFromLocInput: any = $scope.find('#smartalertsOrigin');
		let $smAlertsToLocInput: any = $scope.find('#smartalertsDestination');

		$smartAlertsButton.on('click', (evt: any) => {
			let _self = this;
			evt.preventDefault();
			this.$smAlertsError = [];
			let formDataValid = true;
			_self.$smAlertsErrorValidation.show();
			if ($smAlertsFromLocInput.val() == '') {
				$smAlertsFromLocInput.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$smAlertsFromLocInput.parent().find('.booking-form--title').addClass('has-error');
				formDataValid = false;
				let $smAlertsFromLocValidate: any = $smAlertsFromLocInput.attr('data-preferredcity');
				this.$smAlertsError.push('<strong>' + $smAlertsFromLocInput.parent().find('.booking-form--title').text() + ':</strong> ' + $smAlertsFromLocValidate);
			} else {
				$smAlertsFromLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$smAlertsFromLocInput.parent().find('.booking-form--title').removeClass('has-error');
			}
			if ($smAlertsToLocInput.val() == '') {
				$smAlertsToLocInput.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$smAlertsToLocInput.parent().find('.booking-form--title').addClass('has-error');
				formDataValid = false;
				let $smAlertsToLocValidate: any = $smAlertsToLocInput.attr('data-preferredcity');
				this.$smAlertsError.push('<strong>' + $smAlertsToLocInput.parent().find('.booking-form--title').text() + ':</strong> ' + $smAlertsToLocValidate);
			} else {
				$smAlertsToLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$smAlertsToLocInput.parent().find('.booking-form--title').removeClass('has-error');
			}
			if ($smAlertsFromLocInput.val().split('_')[0] === $smAlertsToLocInput.val()) {
				$smAlertsToLocInput.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$smAlertsToLocInput.parent().find('.booking-form--title').addClass('has-error');
				formDataValid = false;
				if (!($smAlertsFromLocInput.val() == '' || $smAlertsToLocInput.val() == '')) {
					let $smAlertsfromLoLocValidate: any = $smAlertsFromLocInput.attr('data-deptDestLoc');
					this.$smAlertsError.push('<strong>' + $smAlertsToLocInput.parent().find('.booking-form--title').text() + ':</strong> ' + $smAlertsfromLoLocValidate);
				}
			}
			let $validationContainer: any = _self.$smAlertsValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist: any = $validationContainer;

			for (var i = 0, len = this.$smAlertsError.length; i < len; i++) {
				$validationMessagelist.append('<li data-id="' + i + '">' + this.$smAlertsError[i] + '</li>');
			}
			if (formDataValid === true) {
				_self.$smAlertsErrorValidation.hide();
				$.magnificPopup.proto.close.call(this);
			}
		});

	}
	smartAlertsScriptinit(): any {
		(function (d, s, id, p) {
			if (d.getElementById(id)) return;
			window.Jumpseat = {
				partner_id: p,
				queue: [],
				run: function (m: any, p: any) { this.queue.push({ method: m, params: p }); }
			};
			var js, fjs = d.getElementsByTagName(s)[0];
			js = d.createElement(s); js.id = id;
			js.src = "//jumpseat-cdn.volantio.com/static/v3/javascripts/custom/" + p + "/jumpseat.js";
			js.charset = "UTF-8";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'jumpseat-js', 'malaysia'));
	}
	initSelectize(listItems: string): void {
		let _self = this;
		let bcommon = _self.bcommon;

		// desktop fields
		let $scope: any = $('#smart-alerts-popup');
		let $smAlertsFromLoc: any = $scope.find('.smartalertsOrigin');
		let $smAlertsFromLocInput: any = $scope.find('#smartalertsOrigin');
		let $smAlertsToLoc: any = $scope.find('.smartalertsDestination');
		let $smAlertsToLocInput: any = $scope.find('#smartalertsDestination');

		$smAlertsFromLocInput.html(listItems);
		$smAlertsFromLocInput.selectize({
			onInitialize: function () {
				_self.wcag.selectizeInputAria($smAlertsFromLocInput[0].selectize);
			},
			onFocus: function () {
				$smAlertsFromLoc.find('.booking-form--title').addClass('input-filled');
				$smAlertsFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$smAlertsFromLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$smAlertsFromLocInput.parent().find('.booking-form--title').removeClass('has-error');
				let $fromLocationChange = $smAlertsFromLocInput.find('option:selected').text();
				if ($fromLocationChange !== '') {
					$smAlertsFromLocInput[0].selectize.clear();
				}
			},
			onChange: function (value: string) {
				$smAlertsFromLoc.find('.booking-form--title').addClass('input-filled');
				$smAlertsFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				if (value.length) { // only get new toLocation values if fromLocation val is filled (do nothing if empty value)
					bcommon.updatesmartAlertsAirportList("smartAlerts", value, $smAlertsToLocInput);
				}
				if (value != "") {
					setTimeout(function () {
						$smAlertsToLoc.find('input[type="select-one"]').focus();
						$smAlertsToLoc.find('.booking-form--title').addClass('input-filled');
						$smAlertsToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
					}, 300);
					if ($smAlertsFromLocInput.val() !== '' && $smAlertsToLocInput.val() !== '') {
						if ($smAlertsFromLocInput.val() !== $smAlertsToLocInput.val()) {
							let language: any = Cookies.get('session-selected-language');
							let destLanguage: any = 'en-MY';
							if (language === "ms" || language === "my") {
								destLanguage = 'ms-MY';
							}
							else if (language === "cn" || language === "zh_CN") {
								destLanguage = 'zh-CN';
							}
							window.Jumpseat.run('initWatchPrice', {
								content_selector: '.smartalertsSubmit',
								button_selector: '.smartalerts-btn',
								culture_code: destLanguage,
								origin_code: $smAlertsFromLocInput.val().split('_')[0],
								destination_code: $smAlertsToLocInput.val().split('_')[0],
								enable_prompt_on_exit: true,
								enable_prompt_on_idle: true,
								prompt_on_idle_timeout: 90
							});
						}
					}
				}
			},
			onBlur: function () {
				let $smAlertsFromLocationChange = $smAlertsFromLocInput.find('option:selected').text();
				if ($smAlertsFromLocationChange == '') {
					$smAlertsFromLoc.find('.booking-form--title').removeClass('input-filled');
					$smAlertsFromLoc.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$smAlertsFromLoc.find('.booking-form--title').addClass('input-filled');
					$smAlertsFromLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			onLoad: function (data: any) {
				$smAlertsFromLocInput[0].selectize.trigger('blur');
			},
			lockOptgroupOrder: true,
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
						'</div>';

				},
				option: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ',</span> ' +
							escape(item.text.split('|')[1]) + '<span class = "airportcode">' +
							escape(item.text.split('|')[2]) + '</span>' : '') +
						'</div>';
				}
			}
		});

		$smAlertsToLocInput.html(listItems);
		$smAlertsToLocInput.selectize({
			onInitialize: function () {
				_self.wcag.selectizeInputAria($smAlertsToLocInput[0].selectize);
			},
			onFocus: function () {
				$smAlertsToLoc.find('.booking-form--title').addClass('input-filled');
				$smAlertsToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$smAlertsToLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$smAlertsToLocInput.parent().find('.booking-form--title').removeClass('has-error');
				let $toLocationChange = $smAlertsToLocInput.find('option:selected').text();
				if ($toLocationChange !== '') {
					$smAlertsToLocInput[0].selectize.clear();
				}
			},
			onChange: function (value: any) {
				$smAlertsToLoc.find('.booking-form--title').addClass('input-filled');
				$smAlertsToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				if ($smAlertsFromLocInput.val() === $smAlertsToLocInput.val()) {
					$smAlertsToLocInput.parent().find('.selectize-control .selectize-input').addClass('has-error');
					$smAlertsToLocInput.parent().find('.booking-form--title').addClass('has-error');
				}
				else {
					$smAlertsToLocInput.parent().find('.selectize-control .selectize-input').removeClass('has-error');
					$smAlertsToLocInput.parent().find('.booking-form--title').removeClass('has-error');
					if ($smAlertsFromLocInput.val() !== '' && $smAlertsToLocInput.val() !== '') {
						let language: any = Cookies.get('session-selected-language');
						let destLanguage: any = 'en-MY';
						if (language === "ms" || language === "my") {
							destLanguage = 'ms-MY';
						}
						else if (language === "cn" || language === "zh_CN") {
							destLanguage = 'zh-CN';
						}
						window.Jumpseat.run('initWatchPrice', {
							content_selector: '.smartalertsSubmit',
							button_selector: '.smartalerts-btn',
							culture_code: destLanguage,
							origin_code: $smAlertsFromLocInput.val().split('_')[0],
							destination_code: $smAlertsToLocInput.val().split('_')[0],
							enable_prompt_on_exit: true,
							enable_prompt_on_idle: true,
							prompt_on_idle_timeout: 90
						});
					}
				}
			},
			onBlur: function () {
				let $toLocationChange = $smAlertsToLocInput.find('option:selected').text();
				if ($toLocationChange == '') {
					$smAlertsToLoc.find('.booking-form--title').removeClass('input-filled');
					$smAlertsToLoc.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$smAlertsToLoc.find('.booking-form--title').addClass('input-filled');
					$smAlertsToLoc.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			onLoad: function (data: any) {
				$smAlertsToLocInput[0].selectize.trigger('blur');
			},
			lockOptgroupOrder: true,
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
						'</div>';
				},
				option: function (item: any, escape: any) {
					return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ',</span> ' + escape(item.text.split('|')[1]) + '<span class = "airportcode">' + escape(item.text.split('|')[2]) + '</span>' : '') +
						'</div>';
				}
			}
		});
	}
}
let scope: Element = document.querySelector('.smartalerts-container');
if (scope) {
	try {
		let smartalertswidget = new smartAlertsWidget();
		let bookingformcommon = new bookingFormCommon();
		window['smartAlertsOnDList'] = $.Deferred();
		bookingformcommon.getSmartAlertsAirPorts().done((listData: any) => {
			window['smartAlertsOnDList'].resolve(listData);
		});
		window['smartAlertsOnDList'].promise();

		$.when(window['smartAlertsOnDList']).done((listData: any) => {
			// onload use revenue OnD
			let listItems: string = bookingformcommon.parseSmartAlertsOND(listData, 'smartAlerts', 'smart');
			smartalertswidget.initSelectize(listItems);
			smartalertswidget.smartAlertsPopUpInit();
			smartalertswidget.smartAlertsScriptinit();
			smartalertswidget.smartAlertsSubmit();
		});
	} catch (e) { console.error(e); }
}